import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import Nlayout from './Nlayout';
import './Rankings.css';
import { FaCrown, FaSearch, FaSyncAlt } from 'react-icons/fa';


export default function Blacklistpublica({ isMobile }) {
    const [usuarios, setUsuarios] = useState([]);
    const [busqueda, setBusqueda] = useState('');
    const [loading, setLoading] = useState(true);

    const obtenerBlacklist = async () => {
        try {
            const res = await axios.get(
                "https://backend.eldenguee.com/solicitudes/blacklistpublica"
            );

            setUsuarios(res.data.blacklist || []);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        obtenerBlacklist();
    }, []);

    // Fallback avatar generator
    const getAvatarUrl = (username) => {
        return `https://api.dicebear.com/7.x/identicon/svg?seed=${encodeURIComponent(username)}`;
    };

    const usuariosFiltrados = (usuarios || [])
        .filter((item) =>
            item.nombre?.toLowerCase().includes(busqueda.trim().toLowerCase())
        );
    const usuariosMostrados = usuariosFiltrados.slice(0, 50);

    return (
        <Nlayout>
            <div className="rankings-container">
                <div className="rankings-content">
                    <div className="rankings-header">
                        <h1 className="rankings-title">Blacklist</h1>

                        <div
                            style={{
                                backgroundColor: 'rgba(239, 68, 68, 0.1)',
                                borderRadius: '10px',
                                padding: '14px 18px',
                                color: '#fca5a5',
                                border: '1px dashed #ef4444',
                                marginBottom: '24px',
                                marginTop: '12px',
                                textAlign: 'center',
                                fontWeight: 'bold',
                                fontSize: '0.95rem',
                                boxShadow: '0 2px 10px rgba(239, 68, 68, 0.15)',
                            }}
                        >
                            ⚠️ Las personas dentro de la blacklist NO PUEDEN GANAR NINGUN TIPO DE SORTEO
                        </div>

                        {/* Buscador */}
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '20px' }}>
                            <div style={{
                                position: 'relative',
                                width: '100%',
                                maxWidth: '480px',
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <FaSearch style={{ position: 'absolute', left: '16px', color: '#94a3b8', fontSize: '0.95rem' }} />
                                <input
                                    type="text"
                                    placeholder="Buscar tu usuario en la blacklist..."
                                    value={busqueda}
                                    onChange={(e) => setBusqueda(e.target.value)}
                                    style={{
                                        width: '100%',
                                        padding: '12px 16px 12px 45px',
                                        borderRadius: '12px',
                                        background: 'rgba(15, 23, 42, 0.6)',
                                        border: '1px solid rgba(255, 255, 255, 0.12)',
                                        color: '#fff',
                                        fontSize: '0.95rem',
                                        outline: 'none',
                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
                                        transition: 'all 0.2s ease',
                                    }}
                                />
                                {busqueda && (
                                    <button
                                        onClick={() => setBusqueda('')}
                                        style={{
                                            position: 'absolute',
                                            right: '14px',
                                            background: 'transparent',
                                            border: 'none',
                                            color: '#94a3b8',
                                            cursor: 'pointer',
                                            fontSize: '1.1rem',
                                            lineHeight: 1
                                        }}
                                    >
                                        ×
                                    </button>
                                )}
                            </div>
                            {!busqueda && usuarios?.length > 50 && (
                                <span style={{ marginTop: '10px', fontSize: '0.83rem', color: '#94a3b8' }}>
                                    Mostrando los primeros 50 usuarios de {usuarios.length}. Usa el buscador arriba si no apareces.
                                </span>
                            )}
                            {busqueda && (
                                <span style={{ marginTop: '10px', fontSize: '0.83rem', color: '#38bdf8' }}>
                                    Encontrados: {usuariosFiltrados.length} {usuariosFiltrados.length > 50 ? '(mostrando primeros 50)' : ''}
                                </span>
                            )}
                        </div>

                        <div className="rankings-table-container">
                            <table className="rankings-table">
                                <thead>
                                    <tr>
                                        <th style={{ width: '80px' }}>#</th>
                                        <th>Usuario</th>
                                        <th style={{ textAlign: 'right' }}>Motivo</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {usuariosMostrados.length > 0 ? (
                                        usuariosMostrados.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td className={`cell-rank`}>
                                                        #{index + 1}
                                                    </td>
                                                    <td>
                                                        <div className="cell-user">
                                                            <img
                                                                src={getAvatarUrl(item.nombre)}
                                                                alt={item.nombre}
                                                                className="cell-user-avatar"
                                                            />
                                                            <span className="cell-username">
                                                                {item.nombre}
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td style={{ textAlign: 'right' }}>
                                                        <span className={`cell-reward-badge`}>
                                                            {item.motivo}
                                                        </span>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="3" style={{ textAlign: 'center', color: '#94a3b8', padding: '30px' }}>
                                                {loading
                                                    ? 'Cargando blacklist...'
                                                    : busqueda
                                                        ? `No se encontró ningún usuario con "${busqueda}"`
                                                        : 'No hay usuarios en blacklist.'}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            </div>
        </Nlayout>
    );
}
